/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_After_LabelInputs */



/**
* | output |
* | --- |
* | "After:" |
*
* @param {Compare_Event_Groups_After_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_after_label = /** @type {((inputs?: Compare_Event_Groups_After_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_After_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Après :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dopo:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("После:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Después:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("后：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("後：")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाद में:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Depois:")
	return /** @type {LocalizedString} */ ("After:")
});